var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[(_vm.webId != null)?_c('FilesMigration',{attrs:{"webId":_vm.webId}}):_c('SolidLoginButton')],1)}
var staticRenderFns = []

export { render, staticRenderFns }